module.exports = __webpack_public_path__ + "img/sj.d27dd8f0.svg";